import { render } from "./rename.vue?vue&type=template&id=7ab78de6"
import script from "./rename.vue?vue&type=script&lang=js"
export * from "./rename.vue?vue&type=script&lang=js"

import "./rename.vue?vue&type=style&index=0&id=7ab78de6&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__